export const APP_STATES = {
  INIT: "init",
  START_QUIZ: "startQuiz",
  SHOW_SCORE: "showScore",
  REVIEW: "review",
};

export const WHITE = "white";

export const TIMER_DURATION = 90
